import { useTranslation } from "../../../../hooks/useTranslation";
import { Button } from "../../../ui/button";
import styles from './index.module.scss';

export const Mobile = () => {
    const { t } = useTranslation();
 
    return (
        <div className={styles.header}>
            <h3 onClick={() => {
                const el = document.getElementById('home');
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth' });
                }
            }}>Timothée Dumas</h3>
            <Button onClick={() => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })}>
                {t('global.contact')}
            </Button>
        </div>
    );
};